import React, { Fragment, useMemo, useState } from 'react'
import './PublicHeader.scss'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import DropDownComponent from 'app_components/commons/DropDownComponent/DropDownComponent';
import ContactForm from 'app_components/screens/landing/ContactForm/ContactForm';
import { IoMenu } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import { Accordion, Card } from 'react-bootstrap';
import { MdExpandMore } from 'react-icons/md';
import { Link, useLocation } from 'react-router-dom';
import { routingService } from 'app_services/routingService';
import LoginUserMenu from 'app_components/modules/loginUserMenu/LoginUserMenu';
import { useSelector } from 'react-redux';
import { CombinedReducers } from 'app_events/index';
import AuthService from 'app_services/secure/auth/authService';
import LoginMoodle from 'app_components/modules/LoginMoodle/LoginMoodle';
import ShoppingCart from 'app_components/commons/shoppingCartIcon/ShoppingCartIcon';
import { customs } from 'app_config/globals'

const logo = require('app_assets/images/logos/header_logo.svg')
const IconUser = require('app_assets/images/icons/IconUser.png')


const PublicHeader = () => {
  const [openContactForm, setOpenContactForm] = useState<boolean>(false)
  const [openMenuMovil, setOpenMenuMovil] = useState<boolean>(false)
  const { isAuth, user } = useSelector((state: CombinedReducers) => state?.auth)
  const userData = user?.data
  const { pathname } = useLocation()
  const authService = useMemo(() => new AuthService(), [])
  const shoppingCartEnabled = customs?.modules?.shoppingCart === 'enabled'

  const buttonClose = () => {
    setOpenContactForm(false)
  }
  const handleOpenMenu = () => {
    setOpenMenuMovil(true)
  }
  const handleCloseMenu = () => {
    setOpenMenuMovil(false)
  }

  const handleClickOpenContact = () => {
    setOpenMenuMovil(false)
    setOpenContactForm(!openContactForm)
  }

  const getIsActiveClass = (urls: string[]) => {
    return urls.some((url) => pathname.includes(url)) ? 'active' : ''
  }

  const handleClickLogout = () => {
    authService.logout()
  }

  return (
    <Fragment>
      <div className='public-header--container'>
        <div className='public-header--container-two'>
          <div>
            <Link to={routingService.getPublicPath()}>
              <img className='public-header-img' src={logo} alt="header-logo" />
            </Link>
          </div>
          <div className='public-header--container-three'>
            <div className='public-header--container-four'>

              <DropDownComponent
                title='Programas'
                className={`public-header-program ${getIsActiveClass(['/business', '/academic-filter'])}`}
              >
                <Link to={routingService.getPublicPath('/academic-filter')}>
                 <DropDownComponent.Item as='div'>Para personas</DropDownComponent.Item>
                </Link>
                <Link to={routingService.getPublicPath('/business')}>
                  <DropDownComponent.Item as='div'>Empresariales</DropDownComponent.Item>
                </Link>
              </DropDownComponent>
              <Link to={routingService.getPublicPath('/icontec-resources')}>
                <ButtonComponent active={pathname.includes('/icontec-resources')} variant='menu-item'>Recursos educativos</ButtonComponent>
              </Link>
              <Link to={routingService.getPublicPath('/alliances')}>
                <ButtonComponent active={pathname.includes('/alliances')} variant='menu-item'>Alianzas</ButtonComponent>
              </Link>
              <Link to={routingService.getPublicPath('/noticias')}>
                <ButtonComponent active={pathname.includes('/noticias')} variant='menu-item'>Noticias</ButtonComponent>
              </Link>
              <ButtonComponent variant='menu-item' onClick={handleClickOpenContact}>
                Contáctanos
              </ButtonComponent>
              {shoppingCartEnabled && (
                <Link to={routingService.getPublicPath('/shopping-cart')} className='public-header--shopping-cart-link'>
                  <ShoppingCart />
                </Link>
              )}
            </div>
            {!isAuth && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <Link to={routingService.getSecurePath()}>
                  <ButtonComponent
                    className='public-header--button-login-first'
                    variant='tertiary'
                    borderRadius={'20px'}
                    textTransform='none'
                  >
                    Iniciar sesión
                  </ButtonComponent>
                </Link>
                <Link to={routingService.getPublicPath("/register")}>
                  <ButtonComponent
                    className='public-header--button-login-first'
                    variant='primary-violet'
                    borderRadius={'20px'}
                    textTransform='none'
                  >
                    Registrarse
                  </ButtonComponent>
                </Link>
              </div>
            )}
            {isAuth && (
              <div className='dropdown'>
                <div className='dropdown-toggle public-header--button-user-menu' id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <img alt='Icono de usuario' src={IconUser}></img>
                </div>
                <div
                  className='dropdown-menu dropdown-menu-right public-header--dropdown'
                  aria-labelledby="dropdownMenuButton"
                >
                  <LoginUserMenu/>
                </div>
              </div>
            )}
          </div>
          <div className='public-header--container-menu-movil'>
            {shoppingCartEnabled && (
              <Link to={routingService.getPublicPath('/shopping-cart')} className='public-header--shopping-cart-link'>
                <ShoppingCart />
              </Link>
            )}
            {openMenuMovil ?
              <IoClose onClick={handleCloseMenu} className='public-header--menu-icon' size={24}/>
              :
              <IoMenu onClick={handleOpenMenu} className='public-header--menu-icon'/>
            }
          </div>

        </div>
      </div>
      <div className={'public-header--contact-form ' + (openContactForm ? '' : 'close')}>
        <ContactForm buttonClose={buttonClose}/>
      </div>
      <div className={'public-header--movil-menu-container ' + (openMenuMovil ? '': 'close')} >
        {isAuth && (
          <div className='public-header--container-user'>
            <img alt='Icono de usuario' src={IconUser}></img>
            <div>
              <p className='public-header--name'>{userData?.profile?.first_name} {userData?.profile?.last_name}</p>
              <p className='public-header--email'>{userData?.email}</p>
            </div>
          </div>
        )}
        <Accordion>
          <Card className={'public-header--title-line'}>
            <Accordion.Toggle as={Card.Header} eventKey="0" className='public-header--accordion-line' >
              <div className='public-header--title-accordion' >
                Programas
                <MdExpandMore color='white'/>
              </div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body style={{padding: 0, display: 'flex', flexDirection: 'column'}}>
                <div className='public-header--accordion-card-body'>
                  <Link to={routingService.getPublicPath('/academic-filter')}>
                   <p>Para personas</p>
                  </Link>
                  <Link to={routingService.getPublicPath('/business')}>
                    <p>Para empresas</p>
                  </Link>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
        <Link to={routingService.getPublicPath('/icontec-resources')}>
         <p className='public-header--options-menu'>Recursos educativos</p>
        </Link>
        <Link to={routingService.getPublicPath('/alliances')}>
         <p className='public-header--options-menu'>Alianzas</p>
        </Link>
        <Link to={routingService.getPublicPath('/noticias')}>
         <p className='public-header--options-menu'>Noticias</p>
        </Link>
        <p onClick={handleClickOpenContact} className='public-header--options-menu'>Contáctanos</p>
        {isAuth ? (
          <>
            <div className='public-header--container-login-button-two'>
              <LoginMoodle>
                <ButtonComponent
                  className='public-header--login-button-two'
                  variant='tertiary'
                  borderRadius={'20px'}
                  textTransform='none'
                >
                  Ir a cursos
                </ButtonComponent>
              </LoginMoodle>
            </div>
            <div style={{
              width: 'calc(100% - 20px)',
              height: '1px',
              backgroundColor: 'white',
              margin: '0px 10px'
            }}/>
            <Link to={routingService.getSecurePath()}>
              <ButtonComponent color='#7C878E' fontWeight={400} fontSize='20px' margin='20px'>
                Mi panel de formación
              </ButtonComponent>
            </Link>
            <ButtonComponent
              color='white'
              fontSize='20px'
              margin='20px'
              onClick={handleClickLogout}
            >
              Cerrar sesión
            </ButtonComponent>
          </>
        ) : (
          <div className='public-header--container-login-button-two'>
            <Link to={routingService.getSecurePath()}>
              <ButtonComponent className='public-header--login-button-two' variant='tertiary' borderRadius={'20px'} textTransform='none'> Iniciar sesión</ButtonComponent>
            </Link>
          </div>
        )}
      </div>

    </Fragment>

  )
}

export default PublicHeader


